<template>
  <label class="field dynamic-field">
    <span>
      {{ label }} <em v-if="field.isRequired">*</em>
    </span>

    <template v-if="typeCode === 'Textarea'">
      <textarea
        :value="value"
        :required="field.isRequired"
        :maxlength="2000"
        rows="3"
        @input="$emit('input', $event.target.value)"
      ></textarea>
    </template>

    <template v-else-if="typeCode === 'Select'">
      <select
        :value="value"
        :required="field.isRequired"
        @change="$emit('input', $event.target.value)"
      >
        <option value="">—</option>
        <option v-for="opt in selectOptions" :key="opt" :value="opt">{{ opt }}</option>
      </select>
    </template>

    <template v-else-if="typeCode === 'Checkbox'">
      <div class="cb-wrap">
        <input
          type="checkbox"
          :checked="value === 'true'"
          @change="$emit('input', $event.target.checked ? 'true' : 'false')"
        />
        <span class="cb-text">{{ valueLabel }}</span>
      </div>
    </template>

    <template v-else>
      <input
        :type="htmlInputType"
        :value="value"
        :required="field.isRequired"
        :maxlength="500"
        @input="$emit('input', $event.target.value)"
      />
    </template>
  </label>
</template>

<script>
const TYPE_CODE = {
  0: "Text",
  1: "Textarea",
  2: "Number",
  3: "Email",
  4: "Tel",
  5: "Url",
  6: "Date",
  7: "Select",
  8: "Checkbox",
  9: "File",
};

const HTML_TYPE = {
  Text: "text",
  Number: "number",
  Email: "email",
  Tel: "tel",
  Url: "url",
  Date: "date",
  File: "file",
};

export default {
  name: "DynamicField",
  props: {
    field: { type: Object, required: true },
    value: { type: String, default: "" },
  },
  computed: {
    lang() { return this.$store.state.lang || "az"; },
    label() {
      const f = this.field;
      return (
        f[`label_${this.lang}`] ||
        f.label_en ||
        f.label_az ||
        f.key
      );
    },
    typeCode() { return TYPE_CODE[this.field.fieldType] || "Text"; },
    htmlInputType() { return HTML_TYPE[this.typeCode] || "text"; },
    selectOptions() {
      if (!this.field.optionsJson) return [];
      try {
        const arr = JSON.parse(this.field.optionsJson);
        return Array.isArray(arr) ? arr : [];
      } catch {
        return [];
      }
    },
    valueLabel() {
      const map = {
        az: { yes: "Bəli", no: "Xeyr" },
        de: { yes: "Ja", no: "Nein" },
        en: { yes: "Yes", no: "No" },
        ru: { yes: "Да", no: "Нет" },
        tr: { yes: "Evet", no: "Hayır" },
      };
      const dict = map[this.lang] || map.az;
      return this.value === "true" ? dict.yes : dict.no;
    },
  },
};
</script>

<style lang="scss" scoped>
.dynamic-field {
  display: flex; flex-direction: column; gap: 0.3rem; margin-bottom: 0.85rem;
  > span { font-size: 0.78rem; color: #475569; font-weight: 600;
    em { color: #c0392b; font-style: normal; font-weight: 700; margin-left: 2px; }
  }
  input, textarea, select {
    padding: 0.6rem 0.8rem; border: 1px solid #d0d5dd; border-radius: 6px; font: inherit; outline: none; resize: vertical;
    &:focus { border-color: #2a5298; }
  }
  .cb-wrap { display: flex; align-items: center; gap: 0.5rem; padding: 0.45rem 0.1rem;
    input[type="checkbox"] { width: 18px; height: 18px; padding: 0; }
    .cb-text { color: #1e3c72; font-size: 0.9rem; }
  }
}
</style>
